export default "__VITE_ASSET__b4a63b7e__"